import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useApp } from "../../context/AppContext";
import api from "../../lib/api";
import adminApi from "../../lib/adminApi";
import { ADMIN } from "../../lib/adminI18n";
import { parseDeliveryConfig, DELIVERY_CFG_PREFIX } from "../../lib/catalog";
import { Loader2, Truck, Save } from "lucide-react";

export default function DeliveryTab() {
  const { lang } = useApp();
  const a = ADMIN[lang];
  const [fee, setFee] = useState(79);
  const [freeUntil, setFreeUntil] = useState("");
  const [freeOver, setFreeOver] = useState(399);
  const [storeId, setStoreId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const s = await api.getStores();
      const c = parseDeliveryConfig(s);
      setFee(c.fee); setFreeUntil(c.freeUntil || ""); setFreeOver(c.freeOver); setStoreId(c.storeId);
    } catch { toast.error(a.error); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const save = async () => {
    setSaving(true);
    try {
      if (storeId) { try { await adminApi.deleteStore({ store_id: storeId, is_custom: true }); } catch { /* ignore */ } }
      await adminApi.createStore({ name: `${DELIVERY_CFG_PREFIX}|${Number(fee) || 0}|${freeUntil || ""}|${Number(freeOver) || 0}`, category: "matbutik", color: "#111111" });
      toast.success(a.delSaved);
      await load();
    } catch (e) { toast.error(e?.response?.data?.detail || a.error); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="grid place-items-center py-16 text-muted-foreground"><Loader2 className="h-7 w-7 animate-spin" /></div>;

  return (
    <div data-testid="admin-delivery" className="max-w-lg">
      <div className="rounded-2xl border border-border bg-card p-6">
        <h3 className="font-head font-bold text-lg mb-1 flex items-center gap-2"><Truck className="h-5 w-5 text-primary" /> {a.delTitle}</h3>
        <p className="text-sm text-muted-foreground mb-4">{a.delDesc}</p>
        <label className="text-xs font-semibold text-muted-foreground">{a.delFee}</label>
        <input data-testid="delivery-fee-input" type="number" value={fee} onChange={(e) => setFee(e.target.value)} className="mt-1 mb-4 w-full h-11 rounded-xl border border-border bg-background px-3 outline-none focus:ring-2 focus:ring-primary/40" />
        <label className="text-xs font-semibold text-muted-foreground">{a.delFreeOver}</label>
        <input data-testid="delivery-free-over" type="number" value={freeOver} onChange={(e) => setFreeOver(e.target.value)} className="mt-1 mb-4 w-full h-11 rounded-xl border border-border bg-background px-3 outline-none focus:ring-2 focus:ring-primary/40" />
        <label className="text-xs font-semibold text-muted-foreground">{a.freeUntil}</label>
        <input data-testid="delivery-free-until" type="date" value={freeUntil} onChange={(e) => setFreeUntil(e.target.value)} className="mt-1 mb-4 w-full h-11 rounded-xl border border-border bg-background px-3 outline-none focus:ring-2 focus:ring-primary/40" />
        <button data-testid="delivery-save" disabled={saving} onClick={save} className="w-full h-12 rounded-xl bg-primary text-primary-foreground font-semibold disabled:opacity-60 flex items-center justify-center gap-2">
          {saving ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Save className="h-5 w-5" /> {a.delSave}</>}
        </button>
      </div>
    </div>
  );
}
